export interface INavigationRoute {
  name: string;
  displayName: string;
  meta: { icon: string };
  children?: INavigationRoute[];
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'rewards',
      displayName: 'menu.rewards',
      meta: { icon: 'settings' },
    },
    {
      name: 'events',
      displayName: 'menu.events',
      meta: {
        icon: 'settings',
      },
    },
    // {
    //   name: 'event-teams',
    //   displayName: 'menu.eventTeams',
    //   meta: {
    //     icon: 'settings',
    //   },
    // },
    {
      name: 'event-pools',
      displayName: 'menu.eventPools',
      meta: {
        icon: 'settings',
      },
    },
    {
      name: 'countries',
      displayName: 'menu.countries',
      meta: {
        icon: 'settings',
      },
    },
    {
      name: 'competitions',
      displayName: 'menu.competitions',
      meta: {
        icon: 'settings',
      },
    },
    {
      name: 'teams',
      displayName: 'menu.teams',
      meta: {
        icon: 'settings',
      },
    },

    // {
    //   name: 'event-to-event-pools',
    //   displayName: 'menu.eventToEventPools',
    //   meta: {
    //     icon: 'settings',
    //   },
    // },
    // {
    //   name: 'single-event-forecasts',
    //   displayName: 'menu.singleEvents',
    //   meta: {
    //     icon: 'settings',
    //   },
    // },
    // {
    //   name: 'single-statistics',
    //   displayName: 'menu.singleStatistics',
    //   meta: {
    //     icon: 'settings',
    //   },
    // },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
};
